import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'manage-messages-container',
    templateUrl: './manage-messages.component.html'
})
export class ManageMessagesComponent {}
